import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  danhSachNhomCongViec: {},
  chiTietNhomCongViec: {},
  danhSachMauDuThao: {},
  chiTietNhomCongViecTrongHeThong: [],
  chiTietMauDuThao: {},
  cauHinh: null,
  dongBoDanhMucChung: [],
  dongBoCanBo: [],
  danhSachLinhVuc: [],
  themLinhVuc :{},
  getDanhSachPhongBan : [],
  xoaDanhSachLinhVuc: {},
  danhSachNopLuu: [],
  danhSachDonViNhan: [],
  danhSachDonViGui: [],
  danhSachUyQuyen: {},
  danhSachNguoiUyQuyen: [],
};
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
